// import store from '@/store'

const state = {
  popularParlays: [],
  expansionPanel: 1,
  triggerPopularParlaysReload: 0,
  loadPopularParlaysComplete: 0,
  isLoading: false,
  isPopularParlaysEmpty: false
}

const getters = {
  getPopularParlays (state) {
    return state.popularParlays
  },
  loadPopularParlaysComplete (state) {
    return state.loadPopularParlaysComplete
  },
  getPopularParlay: (state) => (iDFWMarketGroup) => {
    // console.log('getPopularParlay:', iDFWMarketGroup)
    return state.popularParlays.find(pp => pp.IDFWMarketGroup === iDFWMarketGroup)
  },
  getPopularParlaySelection: (state, getters) => (idfoselection, iDFWMarketGroup) => {
    // console.log('getPopularParlaySelection:', idfoselection, iDFWMarketGroup)
    let selection = null
    let popularParlays = iDFWMarketGroup ? [getters.getPopularParlay(iDFWMarketGroup)] : getters.getPopularParlays
    if (popularParlays && popularParlays.length) {
      for (let popularParlay of popularParlays) {
        if (popularParlay && popularParlay.SelectionData && popularParlay.SelectionData.length) {
          for (let selectionData of popularParlay.SelectionData) {
            for (let s of selectionData.selections) {
              if (s.idfoselection === idfoselection || s.idfoselectionsource === idfoselection || s.IdFOSelectionSource === idfoselection) {
                selection = s
                return selection
              }
            }
          }
        }
      }
    }
    return selection
  },
  getTriggerPopularParlaysReload (state) {
    return state.triggerPopularParlaysReload
  },
  getIsLoading (state) {
    return state.isLoading
  },
  getIsPopularParlaysEmpty (state) {
    return state.isPopularParlaysEmpty
  },
  getExpansionPanel (state) {
    return state.expansionPanel
  }
}

const actions = {
}

const mutations = {
  triggerPopularParlaysReload (state) {
    // console.log('triggerPopularParlaysReload')
    state.triggerPopularParlaysReload += 1
  },
  setPopularParlays (state, pp) {
    // console.log('setPopularParlays:', pp)
    state.popularParlays = pp
  },
  setLoadPopularParlaysComplete (state) {
    state.loadPopularParlaysComplete++
  },
  setIsLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setIsPopularParlaysEmpty (state, isPopularParlaysEmpty) {
    state.isPopularParlaysEmpty = isPopularParlaysEmpty
  },
  setExpansionPanel (state, expansionPanel) {
    state.expansionPanel = expansionPanel
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/popularparlays.js